<template>
  
    <div class="area-logada-resultado-container" id="area-logada-resultado-container">
        <modalprotestodetalhe :nrPedidoProtesto="nrPedidoSelecionado" @resposta="respConfirm" v-if="page=='VisualizarPedidoProtesto'"/>
        <modalcertidaodetalhe :nrPedidoCertidao="nrPedidoSelecionado" :certidaoDados="certidaoDetalheSelecionada" @resposta="respConfirm" v-else-if="page=='Certidao'" />
        <modalcancelamentodetalhe :nrPedidoCancelamento="nrPedidoSelecionado" :cancelamentoDados="cancelamentoDetalheSelecionada" @resposta="respConfirm" v-else-if="page=='Cancelamento'" />
        <modalanuenciadetalhe :nrPedidoAnuencia="nrPedidoSelecionado" :anuenciaDados="anuenciaDetalheSelecionada" @resposta="respConfirm" v-else-if="page=='aprovadas'" />
        <div class="table-resultado-header" v-bind="tableStyleProperties">
            <div v-for="coluna in colunasList" class="table-resultado-column" >
                <div v-if="coluna.sortable" class="table-resultado-sort" :id="coluna.key" @click="sortResult(coluna.key)"><div class="sort-icons"></div>{{coluna.label}}</div>
                <div v-else class="" :id="coluna.key" v-html="coluna.label" />
            </div>
        </div>
        <div class="table-resultado-body">
            <div v-for="(row, index) in sortedResult" class="table-resultado-row" v-bind="tableStyleProperties">
                <div v-for="coluna in colunasList" :id="coluna.key + '-result-' + index" class="table-resultado-column">
                    <div v-if="coluna.key == 'details' || coluna.key == 'actions'" id="details-button" class="table-resultado-detail btn-details" @click="exibir(row)">+</div>
                    <span v-else >{{(coluna.isCurrency ? currencyFormatter.format(row[coluna.key]) : (coluna.isNested ? nestedColumn(row, coluna.key): (coluna.isDate ? dateFormat(row[coluna.key]) : row[coluna.key])))}}
                        <div class="table-resultado-column-infolet">{{(coluna.isCurrency? currencyFormatter.format(row[coluna.key]) : (coluna.isNested ? nestedColumn(row, coluna.key): row[coluna.key]))}}</div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import detailscardModal from "@/components/arealogada/pesquisa/resultado/details_modal.vue";
import modalprotestodetalhe from "@/components/modal/protesto_detalhe";
import modalcertidaodetalhe from "@/components/modal/certidao_detalhe";
import modalcancelamentodetalhe from "@/components/modal/cancelamento_detalhe";
import modalanuenciadetalhe from "@/components/modal/anuencia_detalhe";
import { title } from "process";
import Vue from 'vue';

    export default {
        components: {
            detailscardModal,
            modalprotestodetalhe,
            modalcertidaodetalhe,
            modalcancelamentodetalhe,
            modalanuenciadetalhe,
        },
        props:{
            colunas:[],
            resultado:[],
            page:String,
            title:String,
            offsetHeight:'',
        },
        data() {
            return {
                tableStyleProperties:{style:{}},
                sort:{key:'',sorting:''},
                currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
                detailCardBgOptions:{azul:'F2F6FE',amarelo:'FEFDF2',verde:'F2FEF6',vermelho: 'FEF2F2',branco: 'FFFFFF'},
                detailCardBg:'',
                exibirDetalhe:false,
                nrPedidoSelecionado:'',
                certidaoDetalheSelecionada:{},
                cancelamentoDetalheSelecionada:{},
                anuenciaDetalheSelecionada:{},
            }
        },
        methods: {
            respConfirm(res){
                if (res.respostaFinal == "s") {
                    this.exibirDetalhe = false;
                    if(this.page === 'VisualizarPedidoProtesto') this.$bvModal.hide("modal-protesto-detalhe");
                    else if (this.page === 'Certidao' ) this.$bvModal.hide("modal-certidao-detalhe");
                    else if (this.page === 'Cancelamento') this.$bvModal.hide("modal-cancelamento-detalhe");
                    else if (this.page === 'aprovadas') this.$bvModal.hide("modal-anuencia-detalhe");
                }
            },
            nestedColumn(row, columnKey){
                let value;
                let keys = columnKey.split(".");
                for (let k = 0; k < keys.length; k++) {
                    if(k==0) value = row[keys[k]];
                    else value = value[keys[k]];
                }
                return value;
            },
            dateFormat(value) {
                if (value !== "" && value !== undefined && value !== null) {
                    let date = new Date(value);
                    return date.toLocaleDateString("pt-BR", {
                    hour: "numeric",
                    minute: "numeric",
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    });
                }
                return "";
            },
            exibir(row){
                console.log(row);
                console.log(this.page);
                if(this.page === 'VisualizarPedidoProtesto') {
                    this.nrPedidoSelecionado = row.cd_pedido_protesto;
                    this.exibirDetalhe = true;
                }
                else if (this.page === 'Certidao'){
                    this.nrPedidoSelecionado = row.cd_pedido;
                    this.certidaoDetalheSelecionada = row;
                    this.exibirDetalhe = true;
                }
                else if (this.page === 'Cancelamento'){
                    this.nrPedidoSelecionado = row.cd_pedido;
                    this.cancelamentoDetalheSelecionada = row;
                    this.exibirDetalhe = true;
                }
                else if (this.page === 'aprovadas'){
                    this.nrPedidoSelecionado = row.cd_anuencia;
                    this.anuenciaDetalheSelecionada = row;
                    this.exibirDetalhe = true;
                }
                else{
                    this.insertDetailCard(row);
                }
            },
            insertDetailCard(row){
                var ComponentClass = Vue.extend(detailscardModal);
                var detailCardFields = this.detailCardFields();
                var status = '';
                if(row.status !== null && row.status !== undefined){
                    if (row.status.nm_status !== null && row.status.nm_status !== undefined)status = row.status.nm_status;
                    else status = row.status;
                }
                else if (row.cd_status !== null && row.cd_status !== undefined) status = row.cd_status;

                var instance = new ComponentClass({
                    propsData: { item: row, status: status, detailCardFields: detailCardFields, page: this.page}
                })
                instance.$mount();
                var element = document.getElementById('area-logada-resultado-container');
                var body = document.body;
                body.classList.add('noscroll');
                element.appendChild(instance.$el);
            },
            sortResult(key){                
                if(this.sort.key == key){
                    switch (this.sort.sorting) {
                        case 'asc':
                            document.getElementById(key).classList.remove('sort-asc');
                            this.sort.sorting = 'desc';
                            break;
                        case 'desc':
                            this.clearSort();
                            break;
                    }
                }
                else{
                    this.clearSort();
                    this.sort.key = key;
                    this.sort.sorting = 'asc';
                }
                if(this.sort.sorting !== '') document.getElementById(key).classList.add('sort-' + this.sort.sorting);
            },
            clearSort(){
                var elements = document.querySelectorAll(".table-resultado-sort");
                elements.forEach((element) => {
                    element.classList.remove('sort-asc','sort-desc');
                });
                this.sort.key = '';
                this.sort.sorting = '';
            },
            detailCardFields(){
                var card = [];
                switch (this.page) {
                    case 'Painel':
                        card = [
                            [
                                [
                                    {key:'cd_certidao',label:'Nº Certidão',position:0},
                                    {key:'cd_pedido',label:'Nº Pedido',position:1},
                                ],
                                [
                                    {key:'status', position:2}
                                ],
                                [
                                    {key:'nm_solicitante',label:'Solicitante',position:3},
                                ],
                                [
                                    {key:'dataCad',label:'Data de cadastro',position:4, isDate:true},
                                ],
                                [
                                    {key:'vl_orcServ',label:'Valor certidão',position:5, isCurrency:true},
                                    {key:'nm_produto',label:'Tipo pedido',position:6,},
                                ],
                                [
                                    {key:'ds_ocorrencia_titulo',label:'Ocorrência',position:7},
                                ],
                                [
                                    {key:'nr_protocolo',label:'Protocolo',position:8},
                                    {key:'actions',label:'Ações',position:9},
                                ],
                            ]
                        ];
                        break;
                    case 'VisualizarPedidoProtesto':
                        card = [
                            [
                                [
                                    {key:'cd_pedido_protesto',label:'Nº Pedido',position:0},
                                    {key:'nm_nr_titulo',label:'Nº Título',position:1},
                                ],
                                [
                                    {key:'status', position:2}
                                ],
                                [
                                    {key:'nm_devedor',label:'Devedor',position:3},
                                ],
                                [
                                    {key:'dt_cadastro',label:'Data de cadastro',position:4, isDate:true},
                                ],
                                [
                                    {key:'vl_titulo',label:'Valor título',position:5, isCurrency:true},
                                    {key:'vl_custa',label:'Valor retirada',position:6, isCurrency:true},
                                ],
                                [
                                    {key:'ds_ocorrencia_titulo',label:'Ocorrência',position:7},
                                ],
                                [
                                    {key:'nr_protocolo',label:'Protocolo',position:8},
                                    {key:'actions',label:'Ações',position:9},
                                ],
                            ]
                        ];
                        break;
                    case 'aprovadas':
                        card = [
                            [
                                [
                                    {key:'id',label:'Nº Pedido:',position:0},
                                    {key:'nm_nr_titulo',label:'Nº Título',position:1},
                                ],
                                [
                                    {key:'nm_devedor',label:'Devedor',position:2},
                                ],
                                [
                                    {key:'nm_nr_documento_devedor',label:'Documento',position:3, maskDoc:true},
                                    {key:'',label:'UF',position:4},
                                ],
                                [
                                    {key:'',label:'E-mail',position:5},
                                ],
                            ],
                            [
                                [
                                    {key:'dt_cadastro',label:'Data de cadastro',position:0, isDate:true},
                                ],
                                [   
                                    {key:'vl_titulo',label:'Valor título',position:1, isCurrency:true},
                                    {key:'vl_custas',label:'Valor retirada',position:2, isCurrency:true},
                                ],
                                [
                                    {key:'NomeCartorio',label:'Cartório',position:2},
                                ],
                                [
                                    {key:'',label:'Endereço',position:1},
                                    {key:'',label:'UF',position:3},
                                ],
                            ]
                        ];
                    default:
                        break;
                }
                return card;
            }
        },
        mounted() {
            if(this.page === 'Painel') var gridTemplateColumns = 'minmax(105px, 1fr) minmax(105px, 3fr) minmax(105px, 3fr) minmax(43px, 60px)';
            else var gridTemplateColumns = 'minmax(105px, 1fr) minmax(105px, 3fr) minmax(43px, 60px)';
            this.tableStyleProperties.style = {'grid-template-columns': gridTemplateColumns, 'grid-gap': '15px'};
            switch (this.page) {
                case 'Painel':
                    this.detailCardBg = this.detailCardBgOptions.azul
                    break;
                case 'VisualizarPedidoProtesto':
                    this.detailCardBg = this.detailCardBgOptions.azul
                    break;
                case 'certidoes':
                    this.detailCardBg = this.detailCardBgOptions.verde
                    break;
                default:
                    this.detailCardBg = this.detailCardBgOptions.azul
                    break;
            }
        },
        watch: {
            exibirDetalhe(newVal, oldVal) {
                console.log('newVal')
                console.log(newVal)
                console.log('newVal')
                if(newVal) {
                    if(this.page === 'VisualizarPedidoProtesto') this.$bvModal.show("modal-protesto-detalhe");
                    else if (this.page === 'Certidao' ) this.$bvModal.show("modal-certidao-detalhe");
                    else if (this.page === 'Cancelamento') this.$bvModal.show("modal-cancelamento-detalhe");
                    else if (this.page === 'aprovadas') this.$bvModal.show("modal-anuencia-detalhe");
                }
            }
        },
        computed: {
            colunasList: function(){
                if(this.page === 'Painel'){
                    return  [
                        { key: "cd_pedido", label: "Nº Pedido", sortable: false, size:"0.75fr"},
                        { key: "nm_solicitante", label: "Solicitante", sortable: false, size:"1.5fr"},
                        { key: "nm_produto", label: "Tipo Pedido", sortable: false, size:"1fr"},
                        { key: "actions", label: "Exibir", sortable: false, size:"0.5fr"},  
                    ]
                }
                else return this.colunas;
            },
            sortedResult: function() {
                let sortedResult = this.resultado;
                if(this.sort.key !== ''){
                    sortedResult = sortedResult.sort((a,b) => {
                        let fa = a[this.sort.key].toLowerCase(), fb = b[this.sort.key].toLowerCase();
                        if (fa < fb) {
                            return -1
                        }
                        if (fa > fb) {
                            return 1
                        }
                        return 0
                    });
                }
                if(this.sort.sorting == 'desc' ) sortedResult.reverse();
                return sortedResult;  
            },
            filterElement: function(){
                return document.getElementById('area-logada-filtro-container');
            }
        }
    }
</script>
<style>
@media (max-width:1199px) {

    .area-logada-resultado-container{/*width: 100vw;*/height: fit-content;display: flex;flex-flow: column;overflow-x: auto;/*margin-left: -17px;*/margin-left: 0;width: 100%;}
    .area-logada-resultado-container::-webkit-scrollbar{width: 17px;}
    .area-logada-resultado-container::-webkit-scrollbar-track{background:transparent;}
    .area-logada-resultado-container::-webkit-scrollbar-thumb{background-color: #707070;border-left: 18px solid transparent;border-right: 18px solid transparent;background-clip: padding-box;border-radius: 27200px;
                    border-bottom: 8px solid transparent;border-top: 8px solid transparent;
                }
        
            .table-resultado-header,
            .table-resultado-body{width:100% !important;min-width:unset !important;height:fit-content;display:grid;grid-template-rows: auto;overflow-x: hidden;}
                .table-resultado-body::-webkit-scrollbar{width: 17px;}
                .table-resultado-body::-webkit-scrollbar-track{background:transparent;}
                .table-resultado-body::-webkit-scrollbar-thumb{background-color: #707070;border-left: 7px solid transparent;border-right: 7px solid transparent;background-clip: padding-box;border-radius: 72px;
                    border-bottom: 8px solid transparent;border-top: 8px solid transparent;
                }
            .table-resultado-row{grid-column: span 8;grid-auto-flow: column;display: grid;grid-template-columns: repeat(8, 1fr);}


        .table-resultado-column{height: 48px;}
            .table-resultado-column:first-child{padding-left: 20px;}
            .table-resultado-column:last-child{padding-right: 20px;}
                .table-resultado-body .table-resultado-column span{width:100%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
                .table-resultado-body .table-resultado-column span .table-resultado-column-infolet{display:none;width: fit-content;height: fit-content;border: 2px solid #F2AF1D;background-color: #FDF1D5;position:absolute;padding: 2px 6px;margin-top:-54px;margin-left:-8px;}
                .table-resultado-body .table-resultado-column span:hover .table-resultado-column-infolet{width: fit-content;display: flex;}

            .table-resultado-row .table-resultado-column{height: 48px;font: normal normal 200 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display:flex;align-items: center;}
            .table-resultado-header {color: white;font-weight: bold;background-color: var(--primary-color);}
            .table-resultado-header .table-resultado-column{display: flex;align-items: center;}
            .table-resultado-body .table-resultado-row .table-resultado-column{color: var(--secondary-color);}
            .table-resultado-body .table-resultado-row:nth-child(even){background-color: #FFFFFF;}
            .table-resultado-body .table-resultado-row:nth-child(odd) {background-color: #F1F1F1;}
            .table-resultado-sort{display: flex;align-items: center;cursor: pointer;user-select:none;}
                .sort-icons{width:10px;height: 15px;display: flex;flex-flow:column;justify-content: space-between;align-items: center;margin-right: 13px;}
                    .sort-icons::before{content:'';border-bottom:5px solid #00000060;border-left:5px solid transparent;border-right:5px solid transparent;}
                    .sort-icons::after{content:'';border-top:5px solid #00000060;border-left:5px solid transparent;border-right:5px solid transparent;}
                        .table-resultado-sort.sort-asc .sort-icons::before{border-bottom:5px solid white;}
                        .table-resultado-sort.sort-desc .sort-icons::after{border-top:5px solid white;}

                .table-resultado-body .table-resultado-row .table-resultado-detail.btn-details{display:flex;align-items: center;justify-content: center;background: #4780F1 0% 0% no-repeat padding-box;border: 3px solid #4780F1;border-radius: 5px;text-align: center;font: normal normal normal 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #ffffff;cursor: pointer;width: 47px;min-width: 47px;height: 34px;user-select:none;}
                
                .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions{display: flex;align-items: center;justify-content:space-between;height: 20px;width: 76px;}
                .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item{width:20px;height: 20px;}
                .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item.bg-fill{background-color: #7A7A7A; border-radius: 100%;}
                    .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item > * {width:20px;height: 20px;display: flex;justify-content: center;align-items: center;color: #7A7A7A;}
                    .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item.bg-fill > * {color: white;}
                        .table-resultado-body .table-resultado-row.active .table-resultado-detail.container-actions .action-item.item-show > *,
                        .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item > *:hover {color: #597EB5;}
                        .table-resultado-body .table-resultado-row .table-resultado-detail.container-actions .action-item.bg-fill > *:hover {color: white;background-color: #597EB5;border-radius: 100%;}
                
}
</style>
    